import { Button, ErrorAlert, GoBackButton, Heading } from '@repo/ui'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PropsWithChildren } from 'react'

export interface BfnDetailsErrorProps {
  testId: string
}

export default function BfnDetailsErrorPage({
  children,
  testId
}: Readonly<PropsWithChildren<BfnDetailsErrorProps>>) {
  const navigate = useNavigate()
  const { t } = useTranslation('bfnDetails')

  return (
    <div className="flex flex-col items-start">
      <div className="flex items-center gap-0.5">
        <GoBackButton data-testid={`${testId}-go-back-button`} />
        <Heading tag="h1">{t('title')}</Heading>
      </div>

      <ErrorAlert className="mb-2.5 max-w-3xl" data-testid={`${testId}-error`}>
        {children}
      </ErrorAlert>

      <Button
        variant="brand-primary"
        onClick={() => navigate('/')}
        data-testid={`${testId}-back-to-overview-button`}
      >
        {t('error.button_to_bfn_overview')}
      </Button>
    </div>
  )
}
